import { render, staticRenderFns } from "./registrazione.html?vue&type=template&id=3378ec18&"
import script from "./Registrazione.vue?vue&type=script&lang=js&"
export * from "./Registrazione.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports